const types = {
    ALL_COLABORADORES: "@colaborador/ALL",
    UPDATE_COLABORADOR: "@colaborador/UPDATE",
    FILTER_COLABORADOR: "@colaborador/FILTER",
   ADD_COLABORADOR: "@colaborador/ADD",
    RESET_COLABORADOR: "@colaborador/RESET",
   ALL_SERVICES: "@colaborador/ALL_SERVICES",
    UNLINK_COLABORADOR: "@colaborador/UNLINK",
  };
  
  export default types;
  